import { createSlice } from "@reduxjs/toolkit";
import { getTopTalentosThunk } from "./mejoresTalentos.thunks";

const initialState = {
  topTalentos: [],
  loading: false,
  error: null,
};

const rankingSlice = createSlice({
  name: "ranking",
  initialState,
  reducers: {
    clearRankingError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ================================
      // GET TOP 5 TALENTOS
      // ================================
      .addCase(getTopTalentosThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopTalentosThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.topTalentos = action.payload;
      })
      .addCase(getTopTalentosThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearRankingError } = rankingSlice.actions;
export default rankingSlice.reducer;